const baseUrl = '/File';
const baseUrlPresignedFile = '/PresignedFile';
export const fileApiRoutes = {
  baseUrl: "".concat(baseUrl),
  upload: "".concat(baseUrl, "/upload"),
  download: _ref => {
    let fileId = _ref.fileId;
    return "".concat(baseUrl, "/download?fileId=").concat(fileId);
  },
  downloadArchive: "".concat(baseUrl, "/archive/download"),
  downloadPreview: "".concat(baseUrl, "/download-preview"),
  downloadExperimental: "".concat(baseUrl, "/download-experimental"),
  fileInfo: fileId => "".concat(baseUrl, "/fileInfo?fileId=").concat(fileId),
  filesInfo: "".concat(baseUrl, "/files-info"),
  convertToImage: "Pdf/convert-to-image",
  convertToImageById: fileId => "Pdf/".concat(fileId, "/convert-to-image"),
  // PresignedFile
  presignedFileGetUploadUrl: "".concat(baseUrlPresignedFile, "/get-upload-url"),
  presignedFileSetUploadUrl: "".concat(baseUrlPresignedFile, "/set-file-metadata"),
  presignedFileGetDownloadUrl: "".concat(baseUrlPresignedFile, "/get-download-url"),
  presignedFileGetArchiveDownloadUrl: "".concat(baseUrlPresignedFile, "/get-archive-download-url"),
  requestPreviewLinkUrl: fileId => "".concat(baseUrlPresignedFile, "/").concat(fileId, "/request-preview-link")
};